module.exports = __webpack_public_path__ + "img/VANTIQ.184edfc2.png";